import { Dispatch } from "redux";
import { setPriorityLevels } from "src/redux/actions/workRequest";
import { FirebaseDataService } from "src/services/Firebase/data";
import { ServiceType, ServiceTypeList } from "src/types";
import { normalizeServiceTypes } from "src/utils/serviceTypes";

const isServiceTypeResponse = (value: unknown): value is ServiceType => {
  return Boolean(value) && typeof value === "object" && "serviceTypes" in (value as Record<string, unknown>);
};

export const fetchDataHandler = async ({
  loggedInUserId,
  isManager,
  isVendor,
  clientId,
  setSiblingCount,
  setServiceTypes,
  setCountOfServiceType,
  setPageSize,
  setInited,
  dispatch,
}: {
  loggedInUserId: string;
  isManager: boolean;
  isVendor: boolean;
  clientId: string;
  setSiblingCount: React.Dispatch<React.SetStateAction<number>>;
  setServiceTypes: React.Dispatch<React.SetStateAction<ServiceTypeList | undefined>>;
  setCountOfServiceType: React.Dispatch<React.SetStateAction<number>>;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  setInited: React.Dispatch<React.SetStateAction<boolean>>;
  dispatch: Dispatch;
}) => {
  const { data } = await FirebaseDataService.getDataForTicketListPage(loggedInUserId, isManager, isVendor);

  const normalizedServiceTypes = isServiceTypeResponse(data.serviceTypes)
    ? data.serviceTypes.serviceTypes || {}
    : normalizeServiceTypes(data.serviceTypes, clientId);

  const serviceTypesLength = normalizedServiceTypes[clientId]?.length ?? 0;
  const serviceTypesAmount = isServiceTypeResponse(data.serviceTypes)
    ? Number(data.serviceTypes.serviceTypesAmount) || 0
    : serviceTypesLength;

  setSiblingCount(data.siblings);
  setServiceTypes(normalizedServiceTypes);

  if (serviceTypesAmount && serviceTypesLength - serviceTypesAmount > 1) {
    setCountOfServiceType(serviceTypesAmount);
  } else {
    setCountOfServiceType(serviceTypesLength);
  }

  dispatch(setPriorityLevels(data.priorityLevels));
  setPageSize(data.ticketsPerPage);
  setInited(true);
};
